import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Layout, Row, Col, Typography, Checkbox, Avatar, Tag, Button, Input, Table, Flex, Card, Popconfirm, Form, DatePicker, Spin, Space, Drawer, Image, Select, Tooltip, message, Switch, Upload } from 'antd';
import { SearchOutlined, ExportOutlined, EyeOutlined, DeleteOutlined, EditOutlined, LoadingOutlined, UserAddOutlined, LinkOutlined, InboxOutlined, HolderOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { PiArrowArcLeft, PiArrowLeftDuotone, PiArrowRightDuotone, PiFileDocDuotone, PiFilePdfDuotone, PiFilePptDuotone, PiFileTextDuotone, PiFileVideoDuotone, PiFileXlsDuotone, PiFloppyDiskDuotone, PiHandPointingDuotone, PiImagesDuotone, PiPhoneCall, PiPlusDuotone, PiSmileyDuotone, PiStorefrontDuotone, PiTextTDuotone, PiUserDuotone, PiUserFocusDuotone, PiUsersDuotone, PiVideoDuotone, PiWhatsappLogo } from 'react-icons/pi';
import whatsappMobileMokup from '../assets/zipler-mobile-mock-up.png';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import PhoneInput from 'react-phone-input-2';
import dayjs from 'dayjs';
import { FaBold, FaItalic, FaStrikethrough } from 'react-icons/fa';
import { GrMonospace } from 'react-icons/gr';
const { Title, Paragraph } = Typography;
const {TextArea} = Input;
const iconComponents = [
    <PiImagesDuotone size={24} />,
    <PiFileVideoDuotone size={24} />,
    <PiFileTextDuotone size={24} />,
    <PiFilePdfDuotone size={24} />,
    <PiFilePptDuotone size={24} />,
    <PiFileXlsDuotone size={24} />,
];

const Templates = () => {
    const [dataLoading, setDataLoading] = useState(true);
    const [createTemplateDrawer, setCreateTemplateDrawer] = useState(true);
    const [languagesData, setLanguagesData] = useState([]);
    const [isHeader, setIsHeader] = useState(true);
    const [headerType, setHeaderType] = useState('image');
    const [whatsappText, setWhatsapptext] = useState('');
    const [templateName, setTemplateName] = useState('');
    const textAreaRef = useRef(null);
    const [headerVarValue, setHeaderVarValue] = useState('');
    const [whatsappImage, setWhatsappImage] = useState(null);
    const [posterBannerImage, setPosterBannerImage] = useState(null);
    const [posterBannerVideo, setPosterBannerVideo] = useState(null);
    const [posterBannerDocument, setPosterBannerDocument] = useState(null);
    const [templateCategory, setTemplateCategory] = useState('MARKETING');
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const [headerText, setHeaderText] = useState('');
    const optInMessage = useState(true);
    const [showPicker, setShowPicker] = useState(false);
    const pickerRef = useRef(null);
    const [fileId, setFileId] = useState('');
    const [fileName, setFileName] = useState('');
    const [buttonFields, setButtonFields] = useState([]);
    const [inputValues, setInputValues] = useState({});
    const [stepLoader, setStepLoader] = useState(false);
    const [file, setFile] = useState(null);
    const [currentIconIndex, setCurrentIconIndex] = useState(0);
    const [isButtons, setIsButtons] = useState(true);
    const [buttons, setButtons] = useState([]);
    const headerTextRef = useRef(null);
    const [sections, setSections] = useState([
        { id: 'weburl', label: 'Add website url' },
        { id: 'phone', label: 'Add phone number' },
        { id: 'quick', label: 'Add Quick Replies' }
    ]);

    const formatTextForPreview = (text) => {
        let formattedText = text
            .replace(/\*(.*?)\*/g, '<b>$1</b>')
            .replace(/_(.*?)_/g, '<i>$1</i>')
            .replace(/~(.*?)~/g, '<s>$1</s>')
            .replace(/```(.*?)```/gs, '<pre><code>$1</code></pre>');
        return formattedText;
    };

    const fetchLanguages = async () => {
        try {
            const response = await fetch(`${window.API_BASE_URL}/languages`);
            if (!response.ok) {
                throw new Error('Failed to fetch languages');
            }
            const data = await response.json();
            setLanguagesData(data);
        } catch (error) {
            console.error('Error fetching languages:', error);
        }
    };

    const handleButtonInputChange = (type, id, key, value) => {
        setButtonFields(prevFields => {
            const fields = prevFields || [];
            return fields.map(field => {
                if (field.id === id) {
                    return {
                        ...field,
                        [key]: value
                    };
                }
                return field;
            });
        });
    };

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };


    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const newOrder = reorder(sections, result.source.index, result.destination.index);
        setSections(newOrder);
    };

    const customRequest = () => {
        return async ({ action, data, file, filename, headers, onError, onProgress, onSuccess }) => {
            try {
                // Create a FileReader to read the file as a base64 string
                const formData = new FormData();
                formData.append('header_file', file);
                formData.append('is_whatsapp', 'whatsapp');
                formData.append('accessToken', 'token');
                formData.append('wappid', 'wappid');
                
                const response = await fetch(action, {
                    method: 'POST',
                    
                    body: formData
                });
                // Parse the response
                const responseData = await response.json();

                setFileId(responseData.filePath.h);
                setFileName(responseData.fileName);
                // Call onSuccess with the response data and the file
                onSuccess(responseData, file);
            } catch (error) {
                onError(error);
                console.error(error);
            }
        };
    };

    const beforeUpload = (file) => {
        const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJPGOrPNG) {
            message.error('You can only upload JPG/PNG files!');
            return Upload.LIST_IGNORE;
        }
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error('Image must be smaller than 5MB!');
            return Upload.LIST_IGNORE;
        }
        return isJPGOrPNG && isLt5M;
    };

    const beforeUploadVideo = (file) => {
        const isMp4Or3gp = file.type === 'video/mp4' || file.type === 'video/3gp';
        if (!isMp4Or3gp) {
            message.error('You can only upload MP4/3GP files!');
            return Upload.LIST_IGNORE;
        }
        const isLt16M = file.size / 1024 / 1024 < 16;
        if (!isLt16M) {
            message.error('Video must be smaller than 16MB!');
            return Upload.LIST_IGNORE;
        }
        return isMp4Or3gp && isLt16M;
    };

    const beforeUploadDoc = (file) => {
        const isDocPdf = file.type === 'text/plain' || file.type === 'application/pdf' || file.type === 'application/vnd.ms-powerpoint' || file.type === 'application/msword' || file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        if (!isDocPdf) {
            message.error('You can only upload TEXT, PDF, PPT/PPTX, DOC/DOCX, XLX/XLXS file!');
            return Upload.LIST_IGNORE;
        }
        const isLt100M = file.size / 1024 / 1024 < 100;
        if (!isLt100M) {
            message.error('Document file must be smaller than 100MB!');
            return Upload.LIST_IGNORE;
        }
        return isDocPdf && isLt100M;
    };

    const handleChangePosterBanner = (info) => {
        if (info.file.status === 'done') {
            const reader = new FileReader();
            reader.onload = () => setPosterBannerImage(reader.result);
            reader.readAsDataURL(info.file.originFileObj);
        }
    };

    const handleRemovePosterBanner = () => {
        setPosterBannerImage(null);
    };

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const handleChange = (info) => {
        if (info.file.status === 'uploading') {
            setStepLoader(true);
            return;
        }
        if (info.file.status === 'done') {
            const fileType = info.file.originFileObj.type;
            getBase64(info.file.originFileObj, (url) => {
                setStepLoader(false);
                if (fileType === 'image/jpeg' || fileType === 'image/png') {
                    setWhatsappImage(url);
                }
                if (fileType === 'video/mp4' || fileType === 'video/3gp') {
                    setPosterBannerVideo(url);
                }
                if (fileType === 'text/plain' || fileType === 'application/pdf' || fileType === 'application/vnd.ms-powerpoint' || fileType === 'application/msword' || fileType === 'application/vnd.ms-excel' || fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    setPosterBannerDocument(url);
                }

            });
        }
    };

    const handleRemoveWhatsappBanner = () => {
        setWhatsappImage(null);
    };

    const handleRemoveWhatsappVideo = () => {
        setPosterBannerVideo(null);
    };

    const handleRemoveWhatsappDocument = () => {
        setPosterBannerDocument(null);
    };

    const handleChangeButtonCheckbox = (type) => {
        if (buttons.includes(type)) {
            setButtonFields(buttonFields.filter(field => field.type !== type));
            setButtons(buttons.filter(button => button !== type));
        } else {
            if (buttonFields.length < 10) {
                setButtons([...buttons, type]);
                addField(type);
            } else {
                message.error('Maximum 10 buttons can be added.');
            }
        }
    };

    const addField = (type) => {
        if (buttonFields.length < 10) {
            const countForType = buttonFields.filter(field => field.type === type).length;
            if ((type === 'weburl' && countForType < 3) ||
                (type === 'quick' && countForType < 10) ||
                (type === 'phone' && countForType < 1)) {
                setButtonFields([...buttonFields, { id: buttonFields.length + 1, type }]);
            }
        }
    };

    const removeField = (id) => {
        setButtonFields(buttonFields.filter(field => field.id !== id));
    };

    const props = {
        name: 'file',
        multiple: false,
        beforeUpload: (file) => {
            return false;
        },
        onChange(info) {
            const { status } = info.file;

            if (status !== 'uploading') {
                console.log('Selected File:', info.file);
                const file = info.file.originFileObj || info.file;
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    const base64String = reader.result;
                    setFile(base64String);
                };
                reader.onerror = (error) => {
                    console.error('Error converting file to Base64:', error);
                };
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        showUploadList: false,
    };

    const handleEmojiSelect = (emoji) => {
        const textareaRef = textAreaRef.current.resizableTextArea.textArea;
        const cursorPosition = textareaRef.selectionStart;
        const updatedMessage =
            whatsappText.slice(0, cursorPosition) +
            emoji.native +
            whatsappText.slice(cursorPosition);
        setWhatsapptext(updatedMessage);
        setShowPicker(false);
        setTimeout(() => {
            if (textAreaRef) {
                const newCursorPosition = cursorPosition + emoji.native.length;
                textareaRef.focus();
                textareaRef.setSelectionRange(newCursorPosition, newCursorPosition);
            }
        }, 0);
    };

    const handleInputChange = (index, value) => {
        setInputValues((prevValues) => ({
            ...prevValues,
            [index]: value,
        }));
    };

    const handleTextStyle = (type) => {
        const textareaRef = textAreaRef.current.resizableTextArea.textArea;
        const textareaValue = whatsappText || '';
        if (!textareaRef) return;

        const start = textareaRef.selectionStart;
        const end = textareaRef.selectionEnd;
        const selectedText = textareaValue.substring(start, end);
        let newText
        switch (type) {
            case 'bold':
                newText = textareaValue.slice(0, start) + `*${selectedText}*` + textareaValue.slice(end);
                break;
            case 'italic':
                newText = textareaValue.slice(0, start) + `_${selectedText}_` + textareaValue.slice(end);
                break;
            case 'strike':
                newText = textareaValue.slice(0, start) + `~${selectedText}~` + textareaValue.slice(end);
                break;
            case 'mono':
                newText = textareaValue.slice(0, start) + `\`\`\`${selectedText}\`\`\`` + textareaValue.slice(end);
                break;
            default:
                newText = textareaValue;
                break;
        }
        setWhatsapptext(newText);
        setTimeout(() => {
            if (textAreaRef) {
                const newCursorPosition = type === 'mono' ? start + (selectedText ? selectedText.length + 3 : 3) : start + (selectedText ? selectedText.length + 2 : 1);
                textareaRef.focus();
                textareaRef.setSelectionRange(newCursorPosition, newCursorPosition);
            }
        }, 0);
    }

    const handleAddVariable = () => {
        const textareaRef = textAreaRef.current.resizableTextArea.textArea;
        const cursorPosition = textareaRef.selectionStart;
        const textareaValue = whatsappText;
        const existingVariables = textareaValue.match(/{{\d+}}/g) || [];
        const existingVariablesCount = existingVariables.length;
        const variable = `{{${existingVariablesCount + 1}}}`;
        const updatedMessage =
            whatsappText.slice(0, cursorPosition) +
            variable +
            whatsappText.slice(cursorPosition);
        setWhatsapptext(updatedMessage);
        setTimeout(() => {
            if (textAreaRef) {
                const newCursorPosition = cursorPosition + variable.length;
                textareaRef.focus();
                textareaRef.setSelectionRange(newCursorPosition, newCursorPosition);
            }
        }, 0);
    };

    const handleAddVariableToHeader = () => {
        const textareaRef = headerTextRef.current.resizableTextArea.textArea;
        const cursorPosition = textareaRef.selectionStart;
        const textareaValue = headerText;
        const existingVariables = textareaValue.match(/{{\d+}}/g) || [];
        const existingVariablesCount = existingVariables.length;
        if (existingVariablesCount < 1) {
            const variable = `{{${existingVariablesCount + 1}}}`;
            const updatedMessage =
                headerText.slice(0, cursorPosition) +
                variable +
                headerText.slice(cursorPosition);
            setHeaderText(updatedMessage);
            setTimeout(() => {
                if (textAreaRef) {
                    const newCursorPosition = cursorPosition + variable.length;
                    textareaRef.focus();
                    textareaRef.setSelectionRange(newCursorPosition, newCursorPosition);
                }
            }, 0);
        } else {
            message.error('Only one variable is allowed.');
        }
    };

    const handleTextChange = (e) => {
        setWhatsapptext(e.target.value);
    };


    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIconIndex((prevIndex) => (prevIndex + 1) % iconComponents.length);
        }, 500);

        return () => clearInterval(interval);
    }, []);

    const handletemplateNameInputChange = (e) => {
        const value = e.target.value
            .replace(/\s+/g, '_')
            .toLowerCase()
            .replace(/[^a-z0-9_]/g, '');
        setTemplateName(value);
    };

    return (
        <Layout className='contentLayout'>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
                <Title level={3} style={{ display: 'flex', alignItems: 'center', margin: 0 }}><b>Templates</b></Title>
            </div>
            <Row gutter={[16, 16]}>
                <Col span={12}>

                </Col>
            </Row>
            <Drawer placement='bottom' closable={false} onClose={() => setCreateTemplateDrawer(false)} open={createTemplateDrawer} className='templateDrawer' height="100vh">
                <Row style={{ height: '100vh', overflow: 'hidden' }}>
                    <Col span={24} style={{ height: '10vh', overflow: 'hidden' }}>
                        <Flex gap='middle' style={{ padding: '16px 24px 10px 24px' }} justify='space-between' align='center'>
                            <Flex gap='small' justify='center' align='center'>
                                <Button shape='round' className='close-btn' onClick={() => setCreateTemplateDrawer(false)}><PiArrowLeftDuotone /></Button>
                                <PiPlusDuotone size={20} /> <Title level={5} style={{ margin: 0 }}>Create New Template</Title>
                            </Flex>
                            <Flex gap='small' justify='center' align='center'>
                                <Button onClick={() => setCreateTemplateDrawer(false)}><PiFloppyDiskDuotone /> Save & Exit</Button>
                                <Button type='primary' onClick={() => setCreateTemplateDrawer(false)}>Active Now <PiArrowRightDuotone /></Button>
                            </Flex>
                        </Flex>
                    </Col>
                    <Col span={14}>
                        <Flex justify='center' style={{ height: '100%' }}>
                            <div className='campaign-whatsapp-left'>
                                <Title level={3} style={{ marginTop: 0, marginBlock: 24, textAlign: 'center' }}>Review WhatsApp Message</Title>
                                <div className='whatsapp-preview-card'>
                                    <img src={whatsappMobileMokup} className='back-mobile' alt='phone' />
                                    <div className='preview-whatsapp-card'>
                                        <div className='whatsapp-message'>
                                            {isHeader && (
                                                headerType === 'image' ? (
                                                    <div className='whatsapp-banner-image'>
                                                        <Image preview={false} src={whatsappImage ? whatsappImage : posterBannerImage && posterBannerImage} style={{ width: '100%' }} />
                                                    </div>
                                                ) : headerType === 'video' ? (
                                                    <div className='whatsapp-banner-image'>
                                                        {posterBannerVideo ? (
                                                            <video controls autoPlay muted style={{ width: '100%' }}>
                                                                <source src={posterBannerVideo} type="video/mp4" />
                                                            </video>
                                                        ) : (
                                                            <PiVideoDuotone size={100} color='#A7A7A7' />
                                                        )}
                                                    </div>
                                                ) : headerType === 'document' ? (
                                                    <div className='whatsapp-banner-image'>
                                                        {posterBannerDocument ? (
                                                            <PiFileDocDuotone size={100} color='#A7A7A7' />
                                                        ) : (
                                                            <PiFileDocDuotone size={100} color='#A7A7A7' />
                                                        )}
                                                    </div>
                                                ) : headerType === 'text' && (
                                                    <div style={{ color: '#000000', textAlign: 'left' }}>
                                                        <b>{headerText}</b>
                                                    </div>
                                                )
                                            )}
                                            <div className='message'>
                                                <div
                                                    style={{ whiteSpace: 'pre-wrap' }}
                                                    dangerouslySetInnerHTML={{ __html: formatTextForPreview(whatsappText) }}
                                                />
                                                {optInMessage && (<Paragraph style={{ margin: 0, fontSize: 12, color: '#777' }}>{`Reply STOP to Unsubscribe from {{store-name}}`}</Paragraph>)}
                                            </div>
                                            <div className="preview-section">
                                                <div className="preview-buttons">
                                                    {sections.map((section, index) => (
                                                        <>
                                                            {section.id === 'weburl' && (
                                                                buttonFields.filter(field => field.type === 'weburl').map((field) => (
                                                                    <Button key={field.id} style={{ margin: '4px' }} href={field.url} target="_blank">
                                                                        <LinkOutlined /> {field.text}
                                                                    </Button>
                                                                ))
                                                            )}
                                                            {section.id === 'phone' && (
                                                                buttonFields.filter(field => field.type === 'phone').map((field) => (
                                                                    <Button key={field.id} style={{ margin: '4px' }}>
                                                                        <PiPhoneCall /> {field.text}
                                                                    </Button>
                                                                ))
                                                            )}
                                                            {section.id === 'quick' && (
                                                                buttonFields.filter(field => field.type === 'quick').map((field) => (
                                                                    <Button key={field.id} style={{ margin: '4px' }}>
                                                                        <PiArrowArcLeft /> {field.text}
                                                                    </Button>
                                                                ))
                                                            )}
                                                        </>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Flex>
                    </Col>
                    <Col span={10}>
                        <div className='tempdrawerRightSide'>
                            <Flex justify='center' align='center'>
                                <div>
                                    <Card bordered={false} className='left-div'>
                                        <Title level={4} style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: 4 }}><PiWhatsappLogo size={24} />Template Name</Title>
                                        <Input type='text' value={templateName} placeholder='Enter text for button' onChange={handletemplateNameInputChange} showCount maxLength={512} />
                                        <Title level={4} style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: 4 }}><PiWhatsappLogo size={24} />Category</Title>
                                        <Select placeholder="Choose Category" style={{ width: '100%' }} onChange={(value) => setTemplateCategory(value)} value={templateCategory} showSearch>
                                            <Select.Option key="MARKETING" value="MARKETING">Marketing</Select.Option>
                                            <Select.Option key="UTILITY" value="UTILITY">Utility</Select.Option>
                                            <Select.Option key="AUTHENTICATION" value="AUTHENTICATION">Authentication</Select.Option>
                                        </Select>
                                        <Title level={4} style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: 4 }}><PiWhatsappLogo size={24} />Language</Title>
                                        <Select placeholder="Select Language" style={{ width: '100%' }} onChange={(value) => setSelectedLanguage(value)} value={selectedLanguage} showSearch>
                                            {languagesData.map(lang => (
                                                <Select.Option key={lang.code} value={lang.code}> {lang.name} </Select.Option>
                                            ))}
                                        </Select>
                                    </Card>
                                    <Card bordered={false} className='left-div' style={{ marginTop: 24 }}>
                                        <Title level={4} style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: 4 }}><PiWhatsappLogo size={24} />Edit Message</Title>
                                        <TextArea ref={textAreaRef} style={{ marginTop: 16 }} value={whatsappText} onChange={handleTextChange} rows={6} showCount maxLength={1024} allowClear />
                                        <Flex>
                                            <Tooltip title='Emojis'><Button style={{ paddingLeft: 0, paddingRight: 6, color: '#000' }} type='link' onClick={() => setShowPicker(!showPicker)}><PiSmileyDuotone size={24} /></Button></Tooltip>
                                            <Tooltip title='Bold'><Button style={{ paddingLeft: 0, paddingRight: 6, color: '#000' }} type='link' onClick={() => handleTextStyle('bold')}><FaBold size={18} /></Button></Tooltip>
                                            <Tooltip title='Italic'><Button style={{ paddingLeft: 0, paddingRight: 6, color: '#000' }} type='link' onClick={() => handleTextStyle('italic')}><FaItalic size={18} /></Button></Tooltip>
                                            <Tooltip title='Strikethrough'><Button style={{ paddingLeft: 0, paddingRight: 6, color: '#000' }} type='link' onClick={() => handleTextStyle('strike')}><FaStrikethrough size={18} /></Button></Tooltip>
                                            <Tooltip title='Monospace'><Button style={{ paddingLeft: 0, paddingRight: 6, color: '#000' }} type='link' onClick={() => handleTextStyle('mono')}><GrMonospace size={24} /></Button></Tooltip>
                                            <Tooltip title='Add Variable, These make the content of the message personalized for users'><Button style={{ paddingLeft: 0, paddingRight: 6, color: '#000' }} type='link' onClick={handleAddVariable}><Paragraph style={{ margin: 0, fontSize: 18, fontWeight: 'bold' }}>{`{{${(whatsappText.match(/{{\d+}}/g) || []).length || 1}}}`}</Paragraph></Button></Tooltip>
                                        </Flex>
                                        {/* {showPicker && (
                                            <div ref={pickerRef}>
                                                <Picker data={data} onEmojiSelect={handleEmojiSelect} onClickOutside={() => setShowPicker(showPicker)} />
                                            </div>
                                        )} */}

                                        {whatsappText.match(/{{\d+}}/g)?.map((match, index) => (
                                            <Input key={index} value={inputValues[index] || ''} onChange={(e) => handleInputChange(index, e.target.value)} placeholder={`Enter variable text for ${match}`} style={{ marginTop: 16 }} />
                                        ))}
                                        <div className='opt-in-checkbox'>
                                            <Flex justify='space-between' align='center'>
                                                <Paragraph style={{ margin: 0 }}><b>Opt out message</b></Paragraph>
                                                <Checkbox checked={optInMessage} />
                                            </Flex>
                                            <Paragraph style={{ marginTop: 0 }}>Reply STOP to Unsubscribe from {`{{store-name}}`}</Paragraph>
                                        </div>
                                    </Card>
                                    <Card bordered={false} className='left-div' style={{ marginTop: 24 }}>
                                        <Flex align='center' justify='space-between'>
                                            <Title level={4} style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: 4 }}>{iconComponents[currentIconIndex]} Header</Title>
                                            <Switch onClick={() => setIsHeader(!isHeader)} checked={isHeader} />
                                        </Flex>
                                        <Flex justify='space-evenly'>
                                            <Flex align='centet' justify='center' className={`headerTypeBtn ${headerType === 'image' && 'active'}`} onClick={() => setHeaderType('image')}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <PiImagesDuotone size={30} />
                                                    <Paragraph style={{ marginBottom: 0 }}><b>Image</b></Paragraph>
                                                </div>
                                            </Flex>
                                            <Flex align='centet' justify='center' className={`headerTypeBtn ${headerType === 'video' && 'active'}`} onClick={() => setHeaderType('video')}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <PiVideoDuotone size={30} />
                                                    <Paragraph style={{ marginBottom: 0 }}><b>Video</b></Paragraph>
                                                </div>
                                            </Flex>
                                            <Flex align='centet' justify='center' className={`headerTypeBtn ${headerType === 'image' && 'document'}`} onClick={() => setHeaderType('document')}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <PiFileDocDuotone size={30} />
                                                    <Paragraph style={{ marginBottom: 0 }}><b>Document</b></Paragraph>
                                                </div>
                                            </Flex>
                                            <Flex align='centet' justify='center' className={`headerTypeBtn ${headerType === 'text' && 'active'}`} onClick={() => setHeaderType('text')}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <PiTextTDuotone size={30} />
                                                    <Paragraph style={{ marginBottom: 0 }}><b>Text</b></Paragraph>
                                                </div>
                                            </Flex>
                                        </Flex>
                                        {headerType === 'image' ? (
                                            <div style={{ marginTop: 16 }}>
                                                <Upload.Dragger
                                                    style={{ width: '100%' }}
                                                    name="banner"
                                                    listType="picture"
                                                    beforeUpload={beforeUpload}
                                                    onChange={handleChange}
                                                    maxCount={1}
                                                    accept="image/jpeg, image/png"
                                                    customRequest={(fileInfo) => customRequest()(fileInfo)}
                                                    action={`${window.API_BASE_URL}/templates/upload-media`}
                                                    onRemove={handleRemoveWhatsappBanner}
                                                >
                                                    <p className="ant-upload-drag-icon">
                                                        <InboxOutlined />
                                                    </p>
                                                    <p className="ant-upload-text">{!whatsappImage ? 'Click or drag file to this area to upload' : 'Click or drag file to this area to upload'}</p>
                                                    <p className="ant-upload-hint">Support for a single upload only.</p>
                                                </Upload.Dragger>
                                            </div>
                                        ) : headerType === 'video' ? (
                                            <div style={{ marginTop: 16 }}>
                                                <Upload.Dragger
                                                    style={{ width: '100%' }}
                                                    name="banner"
                                                    listType="picture"
                                                    beforeUpload={beforeUploadVideo}
                                                    onChange={handleChange}
                                                    maxCount={1}
                                                    accept="video/mp4, video/3gp"
                                                    customRequest={(fileInfo) => customRequest()(fileInfo)}
                                                    action={`${window.API_BASE_URL}/templates/upload-media`}
                                                    onRemove={handleRemoveWhatsappVideo}
                                                >
                                                    <p className="ant-upload-drag-icon">
                                                        <InboxOutlined />
                                                    </p>
                                                    <p className="ant-upload-text">{!whatsappImage ? 'Click or drag file to this area to upload' : 'Click or drag file to this area to upload'}</p>
                                                    <p className="ant-upload-hint">Support for a single upload only.</p>
                                                </Upload.Dragger>
                                            </div>
                                        ) : headerType === 'document' ? (
                                            <div style={{ marginTop: 16 }}>
                                                <Upload.Dragger
                                                    style={{ width: '100%' }}
                                                    name="banner"
                                                    listType="picture"
                                                    beforeUpload={beforeUploadDoc}
                                                    onChange={handleChange}
                                                    maxCount={1}
                                                    accept="text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                    customRequest={(fileInfo) => customRequest()(fileInfo)}
                                                    action={`${window.API_BASE_URL}/templates/upload-media`}
                                                    onRemove={handleRemoveWhatsappDocument}
                                                >
                                                    <p className="ant-upload-drag-icon">
                                                        <InboxOutlined />
                                                    </p>
                                                    <p className="ant-upload-text">{!whatsappImage ? 'Click or drag file to this area to upload' : 'Click or drag file to this area to upload'}</p>
                                                    <p className="ant-upload-hint">Support for a single upload only.</p>
                                                </Upload.Dragger>
                                            </div>
                                        ) : headerType === 'text' && (
                                            <div>
                                                <TextArea ref={headerTextRef} value={headerText} onChange={(e) => setHeaderText(e.target.value)} rows={1} placeholder={`Enter text for header`} showCount maxLength={60} allowClear style={{ marginTop: 16 }} />
                                                <Tooltip title='Add Variable, These make the content of the message personalized for users'><Button style={{ paddingLeft: 0, paddingRight: 6, color: '#000' }} type='link' onClick={handleAddVariableToHeader}><Paragraph style={{ margin: 0, fontSize: 18, fontWeight: 'bold' }}>{`{{${(headerText.match(/{{\d+}}/g) || []).length || 1}}}`}</Paragraph></Button></Tooltip>
                                                {(headerText.match(/{{\d+}}/g) || []).length !== 0 && (
                                                    <Input value={headerVarValue} onChange={(e) => setHeaderVarValue(e.target.value)} placeholder={`Enter variable text for {{1}}`} style={{ marginTop: 16 }} />
                                                )}
                                            </div>
                                        )}
                                    </Card>
                                    <Card bordered={false} className='left-div' style={{ marginTop: 24 }}>
                                        <Flex align='center' justify='space-between'>
                                            <Title level={4} style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: 4 }}><PiHandPointingDuotone size={24} /> Buttons</Title>
                                            <Switch onClick={() => setIsButtons(!isButtons)} checked={isButtons} />
                                        </Flex>
                                        <Flex justify='space-between' align='center' style={{ marginTop: 16, border: '1px solid #343434', borderStyle: 'dashed', borderRadius: 8, padding: 8, backgroundColor: '#ddd' }}>
                                            <Paragraph style={{ margin: 0 }}>The total number of buttons cannot exceed 10.</Paragraph>
                                            <Paragraph style={{ margin: 0 }}>{buttonFields.length} / 10</Paragraph>
                                        </Flex>
                                        <DragDropContext onDragEnd={onDragEnd}>
                                            <Droppable droppableId="droppable-sections">
                                                {(provided) => (
                                                    <div {...provided.droppableProps} ref={provided.innerRef} className="chackboxdiv">
                                                        {sections.map((section, index) => (
                                                            <Draggable key={section.id} draggableId={section.id} index={index}>
                                                                {(provided) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        className={`${section.id}btns`}
                                                                    >
                                                                        {section.id === 'weburl' && (
                                                                            <div className='urlbtns'>
                                                                                <HolderOutlined /> <Checkbox
                                                                                    onChange={() => handleChangeButtonCheckbox('weburl')}
                                                                                    checked={buttons.includes('weburl')}
                                                                                >
                                                                                    Add website url
                                                                                </Checkbox>
                                                                                {buttons.includes('weburl') && (
                                                                                    <div className='btnbox'>
                                                                                        {buttonFields.filter(field => field.type === 'weburl').map((field) => (
                                                                                            <span key={field.id}>
                                                                                                <Row gutter={[8, 8]}>
                                                                                                    <Col span={6}>
                                                                                                        <Select value={field.urlType || 'static'} style={{ width: '100%' }} placeholder='Choose url Type' onChange={(value) => handleButtonInputChange('weburl', field.id, 'urlType', value)}>
                                                                                                            <Select.Option value='static'>Static</Select.Option>
                                                                                                            <Select.Option value='dynamic'>Dynamic</Select.Option>
                                                                                                        </Select>
                                                                                                    </Col>
                                                                                                    <Col span={18}>
                                                                                                        <Input type='text' value={field.text} placeholder='Enter text for button' onChange={(e) => handleButtonInputChange('weburl', field.id, 'text', e.target.value)} showCount maxLength={25} />
                                                                                                    </Col>
                                                                                                    <Col span={24}>
                                                                                                        <Input type='text' value={field.url} placeholder='Enter url' onChange={(e) => handleButtonInputChange('weburl', field.id, 'url', e.target.value)} showCount maxLength={200} />
                                                                                                    </Col>
                                                                                                </Row>
                                                                                                <Button style={{ marginTop: 8, marginBottom: 8 }} danger onClick={() => { buttonFields.filter(field => field.type === 'weburl').length === 1 ? handleChangeButtonCheckbox('weburl') : removeField(field.id) }}>
                                                                                                    <CloseOutlined /> Remove
                                                                                                </Button>
                                                                                            </span>
                                                                                        ))}
                                                                                        {buttonFields.length < 10 && buttonFields.filter(field => field.type === 'weburl').length < 3 && (
                                                                                            <Button style={{ marginLeft: 8, marginTop: 8, marginBottom: 8 }} onClick={() => addField('weburl')}>
                                                                                                <PlusOutlined /> Add more url buttons
                                                                                            </Button>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}

                                                                        {section.id === 'phone' && (
                                                                            <div className='phonebtns'>
                                                                                <HolderOutlined /> <Checkbox
                                                                                    onChange={() => handleChangeButtonCheckbox('phone')}
                                                                                    checked={buttons.includes('phone')}
                                                                                >
                                                                                    Add phone number
                                                                                </Checkbox>
                                                                                {buttons.includes('phone') && (
                                                                                    <div className='btnbox'>
                                                                                        {buttonFields.filter(field => field.type === 'phone').map((field) => (
                                                                                            <span key={field.id}>
                                                                                                <Row gutter={[8, 8]}>
                                                                                                    <Col span={24}>
                                                                                                        <PhoneInput country={'in'} value={field.phoneNumber} onChange={(value) => handleButtonInputChange('phone', field.id, 'phoneNumber', value)} enableSearch={true} inputStyle={{ width: '100%' }} />
                                                                                                    </Col>
                                                                                                    <Col span={24}>
                                                                                                        <Input type='text' value={field.text} onChange={(e) => handleButtonInputChange('phone', field.id, 'text', e.target.value)} placeholder='Enter Text for Button' showCount maxLength={25} />
                                                                                                    </Col>
                                                                                                </Row>
                                                                                                <Button style={{ marginTop: 8, marginBottom: 8 }} danger onClick={() => { buttonFields.filter(field => field.type === 'phone').length === 1 ? handleChangeButtonCheckbox('phone') : removeField(field.id) }}>
                                                                                                    <CloseOutlined /> Remove
                                                                                                </Button>
                                                                                            </span>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}

                                                                        {section.id === 'quick' && (
                                                                            <div className='quickreplybtn'>
                                                                                <HolderOutlined /> <Checkbox
                                                                                    onChange={() => handleChangeButtonCheckbox('quick')}
                                                                                    checked={buttons.includes('quick')}
                                                                                >
                                                                                    Add Quick Replies
                                                                                </Checkbox>
                                                                                {buttons.includes('quick') && (
                                                                                    <div className='btnbox'>
                                                                                        {buttonFields.filter(field => field.type === 'quick').map((field) => (
                                                                                            <span key={field.id}>
                                                                                                <Row gutter={[8, 8]}>
                                                                                                    <Col span={24}>
                                                                                                        <Input type='text' value={field.text} onChange={(e) => handleButtonInputChange('quick', field.id, 'text', e.target.value)} placeholder='Enter Text for QuickReply Button' showCount maxLength={25} />
                                                                                                    </Col>
                                                                                                </Row>
                                                                                                <Button style={{ marginTop: 8, marginBottom: 8 }} danger onClick={() => { buttonFields.filter(field => field.type === 'quick').length === 1 ? handleChangeButtonCheckbox('quick') : removeField(field.id) }}>
                                                                                                    <CloseOutlined /> Remove
                                                                                                </Button>
                                                                                            </span>
                                                                                        ))}
                                                                                        {buttonFields.length < 10 && buttonFields.filter(field => field.type === 'quick').length < 10 && (
                                                                                            <Button style={{ marginLeft: 8, marginTop: 8, marginBottom: 8 }} onClick={() => addField('quick')}>
                                                                                                <PlusOutlined /> Add more quickreply buttons
                                                                                            </Button>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </Card>
                                </div>
                            </Flex>
                        </div>
                    </Col>
                </Row>
            </Drawer>
        </Layout>
    );
};
export default Templates;